import { Skeleton, Stack } from '@chakra-ui/react';

export const ListingFiltersSkeletonDesktopRangeSlider = () => (
    <Stack gap={4}>
        <Skeleton width="160px" height="24px" />
        <Skeleton height="20px" />
        <Skeleton height="72px" mt={1} />
    </Stack>
);
